import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './ItemView.css';
import { useCart } from '../../Context/Cartcontext.jsx'; // Import useCart hook
import { getImageUrl } from '../../utils/imageUtils.js'; // Add this import
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ItemView = () => {
    const { id } = useParams();
    const { addToCart } = useCart(); // Use the Cart context
    
    // State to hold the product data, loading state, and error message
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [addedToCart, setAddedToCart] = useState(false); // Track add to cart status
    
    const baseURL="https://backendweb.properteck.lk";
    
    // Fetch product data from API when the component mounts
    useEffect(() => {
        const fetchProductData = async () => {
            try {
                const response = await fetch(`${baseURL}/api/products/getproduct/${id}`);
                if (!response.ok) {
                    throw new Error('Product not found');
                }
                const data = await response.json();
                setItem(data.product); // Assuming 'product' is the key containing the product details
                setLoading(false);
            } catch (error) {
                setError(error.message); // Set error if request fails
                setLoading(false);
            }
        };

        fetchProductData();
    }, [id]);

    // Handle Add to Cart button click
    const handleAddToCart = () => {
        if (item) {
            addToCart({
                id: item._id,
                name: item.name,
                price: item.price,
                imageUrl: item.imageUrl,
            }); // Add the current item to cart
            setAddedToCart(true); // Update UI to show item was added
            
            // Display success toast message
            toast.success(`${item.name} added to cart!`, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            
            // Reset the "Added to Cart" button after 2 seconds
            setTimeout(() => {
                setAddedToCart(false);
            }, 2000);
        }
    };

    // If the data is still loading, show a loading message
    if (loading) {
        return (
            <>
                <div className="ItemView-container">Loading...</div>
                <ToastContainer />
            </>
        );
    }

    // If there was an error fetching the data, show an error message
    if (error) {
        return (
            <>
                <div className="ItemView-container">Error: {error}</div>
                <ToastContainer />
            </>
        );
    }

    // If no item is found, show a "Product not found" message
    if (!item) {
        return (
            <>
                <div className="ItemView-container">Product not found</div>
                <ToastContainer />
            </>
        );
    }

    return (
        <>
            <div className="ItemView-container">
                <div className="ItemView-image">
                    <img src={getImageUrl(item.imageUrl)} alt={item.name} />
                </div>
                <div className="ItemView-details">
                    <h1>{item.name}</h1>
                    <p className="ItemView-price">LKR {item.price.toLocaleString()}.00</p>
                    <span className={`ItemView-status ${item.stock > 0 ? "ItemView-in-stock" : "ItemView-out-of-stock"}`}>
                        {item.stock > 0 ? "In Stock" : "Out of Stock"}
                    </span>
                    <div className="ItemView-features">
                        <h3>Key Features</h3>
                        <ul>
                            {Array.isArray(item.description) ? 
                                item.description.map((desc, index) => (
                                    <li key={index}>{desc}</li>
                                )) : 
                                <li>{item.description}</li>
                            }
                        </ul>
                    </div>
                    {item.stock > 0 && (
                        <button 
                            className={`ItemView-add-to-cart-btn ${addedToCart ? 'ItemView-added' : ''}`}
                            onClick={handleAddToCart}
                            disabled={addedToCart}
                        >
                            {addedToCart ? "Added to Cart!" : "Add to Cart"}
                        </button>
                    )}
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default ItemView;